/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UserSupportDocument = {
    readonly id?: number;
    readonly document_url?: string;
    /**
     * The name of the support document.
     */
    name: string;
    /**
     * The UUID of the support document, used to avoid dangling files in S3.
     */
    readonly uuid?: string;
    /**
     * The description of the support document.
     */
    description?: string | null;
    /**
     * The language of the support document, can be empty.
     */
    language?: UserSupportDocument.language | null;
    /**
     * The type of the support document.
     */
    document_type: UserSupportDocument.document_type;
    document: string;
    /**
     * The file extension of the support document.
     */
    readonly extension?: string | null;
    readonly created_at?: string;
    readonly updated_at?: string;
}

export namespace UserSupportDocument {

    /**
     * The language of the support document, can be empty.
     */
    export enum language {
        ENGLISH = 'English',
        SPANISH = 'Spanish',
    }

    /**
     * The type of the support document.
     */
    export enum document_type {
        MACROCODES = 'macrocodes',
        ICD10CODES = 'icd10codes',
        FAQS = 'faqs',
        REFERENCEGUIDE = 'referenceguide',
        ORDERSUMMARY = 'ordersummary',
        CRITICALRESULTALERTS = 'criticalresultalerts',
        LABORDERSTANDARDS = 'laborderstandards',
    }


}
